<template>
  <div class="EditSingleSwitchWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="EditAutoThreewaySwitchWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back"
                leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="EditAutoThreewaySwitchWidget-main lxn-pos-rel">
      <div class="EditAutoThreewaySwitchWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.EditWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="AddSingleSwitchWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddSingleSwitchWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddSingleSwitchWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddSingleSwitchWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddSingleSwitchWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddSingleSwitchWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddSingleSwitchWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddSingleSwitchWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddSingleSwitchWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddSingleSwitchWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddSingleSwitchWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="EditAutoThreewaySwitchWidget-wrapper-colors lxn-w100">
              <div class="EditAutoThreewaySwitchWidget-wrapper-name-text lxn-w100 lxn-text"
                   :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{ $store.getters.language.texts.Name_text }}
              </div>
              <div class="lxn-w100">
                <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State"
                             v-model="WidgetName" bgColor="#FFFFFF"
                             :placeHolder="$store.getters.language.texts.WidgetName_PlaceHolder" inputType="text"/>
              </div>
              <div class="EditAutoThreewaySwitchWidget-color-item">
                <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{$store.getters.language.texts.Folder_text}}
                </div>
                <div class="lxn-w100">
                  <DropDown v-model="targetFolder" :dropDownContex="dropDownTargetFolder" />
                </div>
              </div>
            </div>
          </template>
        </TitleBox>
        <AutoThreewaySwitchEditItem v-for="(sw, index) in getSwitches" ref="switch" :switch="sw" :activeBoxIndex="activeBoxIndex" :key="index"></AutoThreewaySwitchEditItem>
      </div>
      <div class="EditAutoThreewaySwitchWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE"
                      iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{ $store.getters.language.texts.SaveChanges_button }}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>

import * as CONFIGS from '@/statics/configs.js';
import Logger from '@/statics/logger.js';
import Messaging from '@/statics/messaging.js';
import TopNav from "@/components/TopNav.vue";
import CustomCurve from "@/components/CustomCurve.vue";
import CustomButton from "@/components/CustomButton.vue";
import CustomInput from "@/components/CustomInput.vue";
import TitleBox from "@/components/TitleBox.vue";
import DropDown from "@/components/DropDown.vue";
import SingleSwitch from "@/components/SingleSwitch.vue";
import HUBS from "@/statics/devices/Hubs";
import NODES from "@/statics/devices/Nodes";
import AutoThreewaySwitchEditItem from "@/views/Home/DashBoard/Settings/AutoThreewaySwitchWidget/EditItem";

export default {
  name: 'AutoThreewaySwitchWidget',
  props: {
    index: Number
  },
  components: {
    AutoThreewaySwitchEditItem,
    SingleSwitch,
    TitleBox, CustomInput, CustomButton,
    CustomCurve, TopNav, DropDown
  },
  mounted: function () {
    this.WidgetName = this.widget.name;
    for(let i = 0; i < this.folderList.length; i++){
      if(this.folderList[i].path == this.widget.path){
        this.targetFolder = i;
      }
    }
    this.switches = this.widget.settings?.switches;
    this.switches.forEach((x, i) => {
      x.name = this.node.settings.switches.find(s => s.index === x.index)?.name || (this.$store.getters.language.texts.Node2Settings_title + " " + (i + 1));
      x.state = this.$store.getters.getParameterValue(this.node.index, NODES[this.node.deviceType]['AUTOENABLE' + (i + 1)].PARAMETER_ID) === 1 ? 'on' : 'off';
    });
  },
  data: function () {
    return {
      input1State: '',
      WidgetName: '',
      activeBoxIndex: 0,
      targetFolder: 0,
      folderList: [],
      switches: [],
    }
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    getSwitches: function (){
      return this.switches;
    },
    hubs: function() {
      return JSON.parse(JSON.stringify(this.$store.state.hubs));
    },
    dropDownTargetFolder: function () {
      this.folderListCleaner();
      var dropDownTargetFolder = {
        name: "AddSingleSwitchWidget-TargetOutputNoNc",
        title: this.$store.getters.language.texts.ChooseOutput_text,
        selectedIndex: this.targetFolder,
        data: [
          {
            name: this.$store.getters.language.texts.Root_text,
            icon: 'folder',
          },
        ]
      };
      this.folderListSetter(
          {
            widgetIndex: -1,
          }
      );
      for(var i = 0; i < this.$store.state.widgets.length; i++){
        if(this.$store.state.widgets[i].type == "folderWidget"){
          var folderWidget = this.$store.state.widgets[i];
          var parentPath = folderWidget.settings.parent;
          var parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          var folderName = folderWidget.name;
          while(parentFolder.length){
            folderName = parentFolder[0].name + " > " + folderName;
            parentPath = parentFolder[0].settings.parent;
            parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          }
          this.folderListSetter(
              {
                path: folderWidget.settings.path,
              }
          );
          dropDownTargetFolder.data.push({
            name: folderName,
            icon: "folder",
          })
        }
      }
      return dropDownTargetFolder;
    },
    widget: function () {
      return this.$store.state.widgets[this.$route.params.widgetIndex];
    },
    timeDelay: function () {
      return this.widget.timeDelay;
    },
    widgetColor: function () {
      return this.$store.state.themeMainColors[this.widget.color];
    },
    node: function () {
      return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.widget.hubUUID);
    },
    output: function () {
      return this.node.outputs[this.widget.settings.outputIndex];
    },
    input: function () {
      // we want in1 -> out1 and in2 -> out2 so their index is the same
      return this.node.inputs[this.widget.settings.outputIndex];
    },
  },
  methods: {
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    folderListSetter: function (obj) {
      this.folderList.push(obj);
    },
    folderListCleaner: function () {
      this.folderList = [];
    },
    toggleSwitchState: function (sw) {
      sw.state = sw.state === 'on' ? 'off' : 'on';
    },
    dropDownInputsChange: function (sw) {
      if (sw.targetInput === '' || sw.targetInput === null) {
        sw.state = 'off';
      }
    },
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName === ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.WidgetName_alert);
      } else {
        const nodeUUIDs = [this.node.uuid];
        const hubUUID = this.hub.uuid;
        const path = this.folderList[this.targetFolder].path;
        const switches = this.$refs.switch.map(s => {
          const x = s.getData();
          return x !== null ? {
            instructionIds: x.instructionIds,
            delay: parseInt(x.delay),
            state: x.state,
            targetInput: x.targetInput,
            index: x.index,
          } : null;
        });
        // if (switches.some(x => x == null)){
        //   alert(this.$store.getters.language.texts.AddNewWidget_autoThreeWay_alert)
        //   return;
        // }
        this.$store.commit('setAppBusy', true);
        const widget = {
          name: this.WidgetName,
          color: this.activeBoxIndex,
          type: "autoThreewaySwitchWidget",
          hubUUID: hubUUID,
          nodeUUIDs: nodeUUIDs,
          visible: true,
          path: path,
          settings: {
            switches: switches
          }
        }
        let messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid,
        });
        const instructions = switches.filter(x => (x.state == 'on' && x.targetInput != null && x.targetInput.input != undefined)).map(x => {
          return [
            {
              instructionId: x.instructionIds[0],
              condition: {
                type: 3,
                output: {
                  deviceUUID: x.targetInput.node.uuid, // تو ورودی انتخاب شده
                  parameterId: x.targetInput.input.parameterId,  // ورودی انتخاب شده ف ج
                  referenceValue: 0,
                  relation: 0,
                }
              },
              onSetNodes: {
                packetType: 0x34,
                actions: [
                  {
                    deviceUUID: this.node.uuid,
                    actions:[{
                      parameterId: NODES[this.node.deviceType]['OUTPUT' + (x.index + 1)].PARAMETER_ID,
                      valueOfChange: 0,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: parseInt(x.delay),   // تایمی که انتخاب کرده
                      cancelCondition: {
                        deviceUUID: x.targetInput.node.uuid, // تو ورودی انتخاب شده
                        parameterId: x.targetInput.input.parameterId,  // ورودی انتخاب شده ف ج
                        referenceValue: 1,
                        relation: 0,
                      },
                    }],
                  },
                ],
              },
              onClearNodes: {
                packetType: 0x34,
                actions: [
                  {
                    deviceUUID: this.node.uuid,
                    actions:[
                      {
                        parameterId: NODES[this.node.deviceType]['OUTPUT' + (x.index + 1)].PARAMETER_ID,
                        valueOfChange: 1,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0,
                      },
                    ],
                  },
                ],
              },
            },
          ];
        }).flatMap(x => x);
        console.log('###### 1111', JSON.parse(JSON.stringify(switches)));
        console.log(instructions);
        console.log('###### 2222', JSON.parse(JSON.stringify(switches.map(x => {
          return {
            parameterId: NODES[this.node.deviceType]['AUTOENABLE' + (x.index + 1)].PARAMETER_ID,
            valueOfChange: x.state === 'on' ? 1 : 0,
            typeOfAction: CONFIGS.ACTION_TYPE_SET,
            timeDelay: 0
          }
        }))));
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.node.uuid,
          bodyContent: {
            nodeActions: [
              {
                nodeUUID: this.node.uuid,
                actions: switches.map(x => {
                  return {
                    parameterId: NODES[this.node.deviceType]['AUTOENABLE' + (x.index + 1)].PARAMETER_ID,
                    valueOfChange: x.state === 'on' ? 1 : 0,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                    timeDelay: 0
                  }
                })
              },
            ]
          }
        })
          .then((res) => {
            var messagingHookSnp = new Messaging(new Logger(false));
            messagingHookSnp.init({
              psk: this.hub.psk,
              destinationUUID: this.hub.uuid,
              sourceUUID: this.$store.state.user.uuid
            });
            this.$store.dispatch('addInstructionsOnHub', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              instructions,
            });
          })
            .finally( response => {
              this.$store.commit('editWidget', {
                widgetIndex: this.$route.params.widgetIndex,
                widget: widget,
              });
              this.$store.commit('saveState');
              this.$router.push('/home/dashboard/');
              this.$store.commit('setAppBusy', false);
            });
      }
    },
  },
}
</script>

<style scoped>

.EditAutoThreewaySwitchWidget-topCurve-wrapper {
  height: 200px;
}

.EditAutoThreewaySwitchWidget-main {
  z-index: 2;
}

.EditAutoThreewaySwitchWidget-main-wrapper {
  width: calc(100% - 36px);
  margin-top: -150px;
  z-index: 2;
  background-color: #ffffff;
  margin-bottom: 14px;
  padding: 14px;
}

.TitleBox.lxn-w100.lxn-border-round.lxn-overflow-hidden {
  background-color: rgb(236, 236, 236);
}

.EditAutoThreewaySwitchWidget-button {
  width: calc(100% - 36px);
  margin-bottom: 14px;
}

.EditAutoThreewaySwitchWidget-wrapper-colors {
}

.EditAutoThreewaySwitchWidget-color {
  width: 100%;
  margin-left: 8px;
  padding: 5px;
}

.EditAutoThreewaySwitchWidget-color-item {
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-bottom: 20px;
}

.EditAutoThreewaySwitchWidget-selectedColor {
  background-color: transparent;
  border-style: solid;
  border-color: #FFFFFF;
  border-width: 4px;
  opacity: 0;
}

.EditAutoThreewaySwitchWidget-color.active .EditAutoThreewaySwitchWidget-selectedColor {
  opacity: 1;
}

.EditAutoThreewaySwitchWidget-wrapper-name-text {
  padding-top: 20px;
  line-height: 30px;
  color: #52626C;
}

.EditAutoThreewaySwitchWidget-wrapper-name-text:first-child {
  height: 30px;
  padding-top: 0;
}

.EditAutoThreewaySwitchWidget-wrapper-fieldTitles {
  height: 30px;
  line-height: 30px;
  color: #52626C;
}

.EditAutoThreewaySwitchWidget-commandDelay-button {
  -webkit-appearance: none;
  transition: opacity 0.5s ease;
  background: #1EA5DE;
  border: 0;
  border-radius: 7px;
  overflow: hidden;
  color: #fff;
  cursor: pointer;
  float: left;
  font-size: 20px;
  height: 40px;
  margin: 0;
  width: 40px;
}

.EditAutoThreewaySwitchWidget-commandDelay-button:hover {
  opacity: 0.5;
}

.EditAutoThreewaySwitchWidget-commandDelay-button:hover {
  opacity: 0.5;
}

.EditAutoThreewaySwitchWidget-commandDelay-button:focus {
  outline: 0;
  outline-offset: 0;
}

.EditAutoThreewaySwitchWidget-wrapper-button2 {
  width: calc(100% - 36px);
  margin-top: 25px;
  margin-bottom: 14px;
}

.EditAutoThreewaySwitchWidget-wrapper-commands {
  height: 70px;
  background-color: #FFFFFF;
  padding: 5px;
  margin-top: 14px;
}

.EditAutoThreewaySwitchWidget-wrapper-commands:first-child {
  margin-top: 0;
}

.EditAutoThreewaySwitchWidget-wrapper-command {
  height: 20px;
  line-height: 20px;
}

.EditAutoThreewaySwitchWidget-wrapper-commands-trash {
  left: 5px;
  top: 5px;
  width: 30px;
  height: 30px;
}

.EditAutoThreewaySwitchWidget-dropdown {
  width: 100%;
  height: 50px;
  background-color: white;
  border: unset;
  box-shadow: unset;
  text-align: center;
}
</style>
